import { Component, OnInit } from '@angular/core';

import { tagsActions } from '@src/store/reducers/tagTypesReducer';

import * as _ from 'lodash';
import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';

const PAGE_SIZE = 10;

@Component({
    selector: 'tag-types-manager',
    template: require('./tag-types-manager.component.html'),
    styles: [require('./tag-types-manager.component.scss')]
})
export class TagTypesManagerComponent implements OnInit {
    public hasItems = false;
    public tagTypes: any[] = [];
    public selectedTagType: any;

    private unSubscribe: any;
    private newTagType = { name: 'New Tag Type', isNew: true, id: -1 };

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService) {
    }

    public ngOnInit() {
        this.unSubscribe = this.store.subscribe(() => {
            const tagsTypes = this.store.getState().tagTypes.tagTypes;
            if (tagsTypes && tagsTypes.length > 0) {
                if (!this.tagTypes || this.tagTypes.length < tagsTypes.length) {
                    this.hasItems = this.tagTypes.length === 0;
                    this.tagTypes = tagsTypes;
                }
                this.unSubscribe();
            }
        });

        this.store.dispatch({
            type: tagsActions.GET_TAG_TYPES_LIST,
            payload: { pageNumber: 1, pageSize: PAGE_SIZE }
        });
    }

    public addTagType() {
        this.tagTypes = [{ ...this.newTagType }, ...this.tagTypes];
        this.hasItems = true;
        this.selectedTagType = this.tagTypes[0];
    }

    public resetTagType(tagType: any) {
        this.unSubscribe = this.store.subscribe(() => {
            this.tagTypes = this.store.getState().tagTypes.tagTypes;
            if (tagType.isNew) {
                this.addTagType();
            }
            this.unSubscribe();
        });
        this.store.dispatch({
            type: tagsActions.GET_TAG_TYPES_LIST,
            payload: { pageNumber: 1, pageSize: PAGE_SIZE }
        });
    }

    public deleteTagType(event: any) {
        if (event.type !== 'click') {
            return;
        }
        this.dialogManagerService.showConfirmationDialog(
            {
                title: 'Delete Tag Type',
                action: 'delete',
                objectType: 'tag type',
                item: this.selectedTagType.name
            },
            () => {
                let tagTypeToDelete = null;
                if (this.selectedTagType.isNew) {
                    this.tagTypes = [...this.tagTypes.slice(0, 0), ...this.tagTypes.slice(1)];
                    tagTypeToDelete = (this.tagTypes) ? this.tagTypes[0] : null;
                    this.selectedTagType = { ...tagTypeToDelete };
                    return;
                }
                this.unSubscribe = this.store.subscribe(() => {
                    const tagTypesState = this.store.getState().tagTypes;
                    if (tagTypesState) {
                        if (this.tagTypes.length > tagTypesState.tagTypes.length) {
                            this.tagTypes = [...tagTypesState.tagTypes];
                            this.selectedTagType = { ...this.tagTypes[0] };
                            this.unSubscribe();
                        }
                    }
                });
                this.store.dispatch({
                    type: tagsActions.DELETE_TAG_TYPE,
                    payload: { tagTypeId: this.selectedTagType.id }
                });
            }
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/tag-types-manager/tag-types-manager.component.ts